import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import TaskDetailsView from '../components/details';
import TaskForm from '../components/forms';
import { ProjectForm } from '../components/projects';
import Task from '../components/Task';
import TaskDesignPreview from '../components/preview/TaskDesignPreview';
import { TaskProvider } from '../../../../core/components/tasks/TaskProvider';
import { ProjectProvider } from '../../../../core/components/projects/ProjectProvider';
import { OrgProvider } from '../../../../core/components/orgs/OrgProvider';
import { UserProvider } from '../../../../core/components/users/UserProvider';
import { CampaignOrderProvider } from '../../../../core/components/campaingOrder/CampaignOrderProvider';
import { ProjectDetails } from '../components/projects';
import { TaskErrorBoundary } from '../components/shared';

const TaskManagementRoutes = (props) => {
  const { path } = props.match;
  document.title = `Task Management`;
  return (
    <UserProvider>
      <OrgProvider>
        <CampaignOrderProvider>
          <ProjectProvider>
            <TaskProvider>
              <div className="task-management">
                <Switch>
                  <Route path={`${path}/design-preview`} exact render={() => <TaskDesignPreview />} />
                  <Route path={`${path}/analytics`} exact render={() => <Task {...props} />} />
                  <Route path={`${path}/admin`} exact render={() => <Task {...props} />} />
                  <Route path={`${path}/projects`} exact render={() => <Task {...props} />} />
                  <Route path={`${path}/projects/new`} exact render={() => <ProjectForm />} />
                  <Route path={`${path}/projects/details/:id?`} exact render={() => <ProjectDetails />} />
                  <Route path={`${path}/main/:pageNumber?`} exact render={() => <Task {...props} />} />
                  <Route path={`${path}/unassigned/:pageNumber?`} exact render={() => <Task {...props} />} />
                  <Route path={`${path}/form/:id?`} exact render={() => <TaskErrorBoundary><TaskForm /></TaskErrorBoundary>} />
                  <Route path={`/tasks/details/:id?`} exact render={() => <TaskErrorBoundary><TaskDetailsView /></TaskErrorBoundary>} />
                  <Route path={`${path}/overdue`} exact render={() => <Task {...props} />} />
                  {/* Fallback - check if PLATFORM user */}
                  <Route path={`${path}`} render={() => {
                    const isPlatformLevel = props.currentUser?.role?.org?.level === 'PLATFORM';
                    return isPlatformLevel
                      ? <Redirect to={`${path}/projects`} />
                      : <Redirect to={`${path}/main/1`} />;
                  }} />
                </Switch>
              </div>
            </TaskProvider>
          </ProjectProvider>
        </CampaignOrderProvider>
      </OrgProvider>
    </UserProvider>
  );
};

export default TaskManagementRoutes;
